module.exports = __webpack_public_path__ + "img/37863-046.4d65f1d1.jpg";